// @flow
import React, {Component} from 'react';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import Modal from '@homeaway/react-modal';
import {ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import './SortLegalDisclaimer.less';

import type {IntlShape} from 'react-intl';
import type {Breakpoint} from '../../utils/breakpoints';
import {media} from '../../utils/breakpoints';
import type {SystemData} from '../../../server/utils/systemData';

type State = {
    isOpen: boolean
};

type Props = {
    intl: IntlShape,
    breakpoint: Breakpoint,
    system: SystemData
};

export default class SortLegalDisclaimer extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    handleOpen = () => {
        this.setState({isOpen: true});
    };

    handleClose = () => {
        this.setState({isOpen: false});
    };

    render() {
        const {intl, breakpoint, system} = this.props;
        const isMobile = !media(breakpoint, {minWidth: 'SM_MIN'});

        const doneButtonLabel = intl.formatMessage({
            id: 'done',
            description: 'Close modal button',
            defaultMessage: 'Done'
        });

        const legalLinkLabel = intl.formatMessage({
            id: 'sort.legal.linkText',
            description: 'link label to open legal modal',
            defaultMessage: 'Learn more'
        });

        const legalModalTitleLabel = intl.formatMessage({
            id: 'sort.legal.title',
            description: 'Legal modal caption',
            defaultMessage: 'How we determine our sort order'
        });

        const DoneButton = (
            <ButtonPrimary
                className="SortLegalDisclaimer__ModalDoneButton"
                onClick={this.handleClose}
                label={doneButtonLabel}
            />
        );
        const buttonLinkSize = isMobile ? 'sm' : null;

        return (
            <div className="SortLegalDisclaimer">
                <div
                    className={classNames('SortLegalDisclaimer__legalMessage', {
                        small: isMobile
                    })}
                >
                    <ButtonLink
                        className="SortLegalDisclaimer__linkButton"
                        label={legalLinkLabel}
                        onClick={this.handleOpen}
                        size={buttonLinkSize}
                    />
                    <FormattedMessage
                        id="sort.legal.text"
                        defaultMessage="about HomeAway Sort"
                    />
                </div>
                <Modal
                    id="sortLegalModal"
                    closeText={doneButtonLabel}
                    isOpen={this.state.isOpen}
                    footer={DoneButton}
                    onClose={this.handleClose}
                    title={legalModalTitleLabel}
                >
                    <FormattedHTMLMessage
                        id="sort.legal.message"
                        description="Legal modal explanation"
                        values={{
                            siteName: system.brand
                        }}
                    />
                </Modal>
            </div>
        );
    }
}
